import { Modal, Button } from "@components/index";
import { PrivateUseModel } from "@interfaces/index";
import { getPrivateUseValue } from "@utils/index";
import AlertImg from "@assets/images/alert-triangle.svg";

export const PrivateUseReviewModal = ({
  show,
  privateUses,
  onClose,
  onConfirm,
  onEdit,
}: {
  show: boolean;
  privateUses?: PrivateUseModel[];
  onClose: () => void;
  onConfirm: () => void;
  onEdit: () => void;
}) => (
  <Modal show={show} onClose={onClose}>
    <div className="flex flex-col items-center text-center">
      <img src={AlertImg} alt="Alert" className="h-12 w-12 md:h-14 md:w-14" />
      <div className="pt-4 text-300 text-black-70">
        Please review your Private Use percentage. Confirm if it's correct or
        edit the figures if needed.
        <br />
        <br />
        {privateUses
          ?.filter(({ categoryTitle }) =>
            ["Motor", "Internet", "Mobile", "Computer costs"].includes(
              categoryTitle,
            ),
          )
          .map((category) =>
            category.assets.map((asset) => (
              <div
                key={`${category.categoryId}---${asset.assetId || "0"}`}
                className="flex gap-x-2"
              >
                <div className="w-64 text-right">
                  {category.categoryTitle}
                  {asset.assetName ? ` - ${asset.assetName}` : ""}:
                </div>
                <div className="w-20 text-left">
                  {getPrivateUseValue(asset, "0")}%
                </div>
              </div>
            )),
          )}
      </div>
    </div>
    <div className="flex justify-between gap-x-2 pt-8 md:gap-x-8 md:pt-12">
      <Button
        type="button"
        variant="primary"
        title="Confirm"
        className="mx-auto w-40"
        onClick={onConfirm}
      />
      <Button
        type="button"
        variant="primary"
        title="Edit"
        className="mx-auto w-40"
        onClick={onEdit}
      />
    </div>
  </Modal>
);
